module.exports = __webpack_public_path__ + "static/media/star.4738a829.svg";